import { render, staticRenderFns } from "./YMAdditionalParams.vue?vue&type=template&id=9766d60e"
import script from "./YMAdditionalParams.vue?vue&type=script&lang=js"
export * from "./YMAdditionalParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports